import PointSpace from "./PointSpace"
import DistanceSpace from "./DistanceSpace"
import DistanceGround from "./DistanceGround"
import AreaSpace from "./AreaSpace"
import AreaGround from "./AreaGround"
import HeightSpace from "./HeightSpace"
import BearSpace from "./BearSpace"
import AngleSpace from "./AngleSpace";
import ExcavationCalc from "./ExcavationCalc"
import IntervisibilePoint from "./IntervisibilePoint"
import IntervisibileCircle from "./IntervisibileCircle"
import SlopeAnalysis from "./SlopeAnalysis"
import ViewShedAnalysis from "./ViewShedAnalysis"
//分析管理类
class AnalysisManage {

    constructor(options) {
        this.options = options;
        this.DrawIns = {};
        this.init(); //
    }

    init() {
        this.DrawIns['pointSpace'] = new PointSpace(this.options);
        this.DrawIns['lineSpace'] = new DistanceSpace(this.options);
        this.DrawIns['lineGround'] = new DistanceGround(this.options);
        this.DrawIns['areaSpace'] = new AreaSpace(this.options);
        this.DrawIns['areaGround'] = new AreaGround(this.options);
        this.DrawIns['heightSpace'] = new HeightSpace(this.options);
        this.DrawIns['bearSpace'] = new BearSpace(this.options);
        this.DrawIns['angleSpace'] = new AngleSpace(this.options);
        this.DrawIns['ecavationCalc'] = new ExcavationCalc(this.options);
        this.DrawIns['intervisibilePoint'] = new IntervisibilePoint(this.options);
        this.DrawIns['intervisibileCircle'] = new IntervisibileCircle(this.options);
        this.DrawIns['slopeAnalysis'] = new SlopeAnalysis(this.options);
        this.DrawIns['viewShedAnalysis'] = new ViewShedAnalysis(this.options);
    }

    //开始
    start(type) {
        this.reset();
        switch (type) {
            case 'pointSpace':
                this.DrawIns[type].start();
                break;
            case 'lineSpace':
                this.DrawIns[type].start();
                break;
            case 'lineGround':
                this.DrawIns[type].start();
                break;
            case 'areaSpace':
                this.DrawIns[type].start();
                break;
            case 'areaGround':
                this.DrawIns[type].start();
                break;
            case 'heightSpace':
                this.DrawIns[type].start();
                break;
            case 'bearSpace':
                this.DrawIns[type].start();
                break;
            case 'angleSpace':
                this.DrawIns[type].start();
                break;
            case 'ecavationCalc':
                this.DrawIns[type].start();
                break;
            case 'intervisibilePoint':
                this.DrawIns[type].start();
                break;
            case 'intervisibileCircle':
                this.DrawIns[type].start();
                break;
            case 'slopeAnalysis':
                this.DrawIns[type].start();
                break;
            case 'viewShedAnalysis':
                this.DrawIns[type].start();
                break;
            default:
                break;
        }
    }

    reset() {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.reset();
        }
    }


    //清空
    clear() {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.clear();
        }
    }
}

export default AnalysisManage